<div class="modal-header d-flex flex-row justify-content-end">
  <button class="button m icon transparent" (click)="close()"><i class="ti ti-x"></i></button>
</div>
<div class="modal-content">
  <div class="chip-icon primary small"><div class="inner"><i class="ti ti-alert-hexagon"></i></div></div>
  <h2 class="mt-4" *ngIf="title">{{ title }}</h2>
  <p class="mt-3" *ngIf="message" [innerHTML]="message"></p>
  <div class="d-flex flex-row gap-3 mt-4" *ngIf="actionRequested">
    <button class="button m light confirm" (click)="close({confirm: false})" type="button" *ngIf="cancelButtonText">{{ cancelButtonText }}</button>
    <button class="button m primary confirm" (click)="close({confirm: true})" type="button">{{ actionButtonText }}</button>
  </div>
</div>
